import Vue from 'vue'
import router from '../router'
import store from 'vuex-store'

let xhrCount = 0

export default {
  apply () {
    Vue.http.options.root = process.env.BASE_API_URL + process.env.API_VERSION

    Vue.http.interceptors.push((request, next) => {
      request.credentials = true
      xhrCount++
      store.commit('setLoadingLight', true)

      // always pass the apikey headers except on cmslogin action
      if (request.url.indexOf('cmslogin') === -1 &&
          request.url.indexOf('cmsping') === -1) {
        request.headers.set('apikey', process.env.API_KEY)
      }

      next((response) => {
        xhrCount--

        if (xhrCount === 0) {
          store.commit('setLoadingLight', false)
        }

        if (request.url.indexOf('cmslogin') === -1) {
          if (request.url.indexOf('cmsping') > -1) {
            if (response.status !== 200) {
              console.warn('Unauthorized, redirecting to login...')
              router.push('/auth/login')
            }
          }

          if (response.status === 401 || response.status === 403) {
            console.warn('Unauthorized, redirecting to login...')
            router.push('/auth/login')
          }
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/application/resource-policies.js